<pbc-sorter [config]="ReisekostenabrechnungenSorterConfig" [sorter]="reisekostenabrechnungen.sorter$ | async" (sorterChange)="reisekostenabrechnungen.sorter$.next($event)"></pbc-sorter>
